module.exports = __webpack_public_path__ + "img/badge-recommendations-gold-brightbg.38400d72.svg";